export const ERROR_MESSAGE = {
  refreshTokenNotFound: 'REFRESH_TOKEN_NOT_FOUND'
};

export const ErrorMessageResponse = {
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOCK_USER: 'ERR_USER_LOCKED',
};
